import { IS_DEVELOPMENT, IS_JEST } from 'shared/consts'

export default !IS_JEST && !IS_DEVELOPMENT
